import classNames from "classnames";

interface LoaderProps {
  containerClassName?: string;
  className?: string;
  size?: "small" | "medium" | "large";
  label?: string;
}

const Loader = (props: LoaderProps) => {
  const { containerClassName = "", className = "", size = "small", label } = props;
  return (
    <div
      className={classNames("flex flex-col items-center justify-center py-5 text-gray-500 gap-2", {
        [containerClassName]: !!containerClassName,
      })}
    >
      <div
        className={classNames(
          "border-solid border-gray-400 border-r-transparent animate-spin inline-block rounded-full",
          {
            "border-2 w-4 h-4": size === "small",
            "border-2 w-6 h-6": size === "medium",
            "border-2 w-8 h-8": size === "large",
            [className]: !!className,
          }
        )}
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
      {!!label && (
        <span
          className={classNames("", {
            "text-sm": size === "small",
            "text-md": size === "medium",
            "text-base": size === "large",
          })}
        >
          {label}
        </span>
      )}
    </div>
  );
};

export default Loader;
